<template>
  <v-container :class="{ 'unidad-embedded-container': embedded }">
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogDependencias" max-width="520px">
          <v-card v-if="dependItem" class="depend-dialog">
            <v-card-title class="depend-dialog__title">
              <v-icon color="warning" left>mdi-alert-outline</v-icon>
              No se puede desactivar la unidad
            </v-card-title>
            <v-card-text>
              <p class="mb-3">
                La unidad <strong>{{ dependItem.nombre }}</strong> no puede desactivarse porque tiene
                <strong>{{ dependItem.variablesAsociadas }} variable(s) asociada(s)</strong>.
              </p>
              <div class="subtitle-2 mb-1">Variables asociadas:</div>
              <ul class="depend-dialog__list">
                <li v-for="(v, i) in (dependItem.variablesAsociadasLista || [])" :key="i">{{ v }}</li>
              </ul>
              <v-alert dense text type="warning" class="mb-0 mt-3">
                Para desactivar esta unidad, primero elimina o cambia la unidad en las variables asociadas.
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDependencias = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-data-table
      v-if="permisoVista('almacen','r')"
      :headers="headers"
      :items="unidades"
      :search="search"
      :loading="loading"
      loading-text="Cargando... Espere, Por Favor."
    >
      <template v-slot:top>
        <v-toolbar v-if="!embedded" flat color="white">
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-if="permisoVista('almacen','c')"
            @click="openCreateExternal"
          >Nueva Unidad</v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-toolbar v-else flat color="transparent" class="unidad-embedded-toolbar">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar unidad"
            single-line
            hide-details
            outlined
            dense
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.variablesAsociadas="{ item }">
        <div class="asoc-cell">
          <span class="asoc-cell__count">
            {{ item.variablesAsociadas || 0 }} variable{{ item.variablesAsociadas === 1 ? '' : 's' }}
          </span>
          <a v-if="item.variablesAsociadas > 0" class="asoc-cell__link" @click="verAsociaciones(item)">Ver detalle</a>
          <span v-else class="asoc-cell__empty">Sin variables</span>
        </div>
      </template>
      <template v-slot:item.condicion="{ item }">
        <v-switch
          :key="'uni-sw-' + item.idUnidad + '-' + estadoNonce"
          :input-value="item.condicion !== false"
          :loading="togglingId === item.idUnidad"
          :disabled="togglingId === item.idUnidad || !(permisoVista('almacen','u') || permisoVista('almacen','d'))"
          color="success"
          dense
          hide-details
          inset
          class="estado-switch"
          :label="item.condicion === false ? 'Inactiva' : 'Activa'"
          @change="toggleEstado(item)"
        ></v-switch>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
          v-if="permisoVista('almacen','u')"
          small
          class="mr-2"
          @click="editItem(item)"
        >
          edit
        </v-icon>
          </template>
          <span class="white--text">Editar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Refrescar</v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent max-width="500px" :key="'unidad-dialog-' + dialog">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col justify="center" cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.codigo" label="Codigo de la Unidad"></v-text-field>
              </v-col>
              <v-col justify="center" cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.nombre" label="Nombre de la Unidad"></v-text-field>
              </v-col>
              <v-col justify="center" cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.abreviatura" label="Abreviatura de la Unidad"></v-text-field>
              </v-col>
              <v-col justify="center" cols="12" sm="12" md="12">
                <v-select v-model="editedItem.numDimensiones" label="Número de Dimensiones" :items="dimensiones"></v-select>
              </v-col>
              <v-col v-if="editedItem.numDimensiones > 1" justify="center" cols="12" sm="12" md="12">
                <v-select v-model="editedItem.idUnidadBase" label="Unidad Base" :items="unidadesBase()" item-text="nombre" item-value="idUnidad"></v-select>
              </v-col>
            </v-row>
            <ul>
              <li class="red--text" v-for="ex in errores" :key="ex">{{ ex }}</li>
            </ul>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog=false; errores=[];">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="save()" :disabled="saving" :loading="saving">
            Guardar
            <template v-slot:loader>
              <v-progress-circular
                indeterminate
                :width="2"
                :size="24"
                color="red"
              ></v-progress-circular>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="alerta"
      top
      color="error"
    >
      Existe una Unidad Activa con el mismo nombre
      <v-btn
        text
        @click="alerta = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>

</template>

<script>
import axios from "axios";

  export default {
    props: {
      embedded: { type: Boolean, default: false },
    },
    data: () => ({
      saving: false,
      dialog: false,
      alerta: false,
      dialogDependencias: false,
      dependItem: null,
      togglingId: null,
      estadoNonce: 0,
      search: '',
      dimensiones: [
        {
          text:"1 Dimensión",
          value: 1,
        },
        {
          text:"2 Dimensiones",
          value: 2,
        },
        {
          text:"3 Dimensiones",
          value: 3,
        }
      ],
      headers: [
        {
          text: 'Codigo',
          align: 'left',
          sortable: true,
          value: 'codigo',
          width:'12%',
        },
        {
          text: 'Unidad',
          align: 'left',
          sortable: true,
          value: 'nombre',
        },
        {
          text: 'Abreviatura',
          align: 'left',
          sortable: true,
          value: 'abreviatura',
          width:'10%',
          align:'center'
        },
        { text: 'Variables asociadas', value: 'variablesAsociadas', sortable: true, align:'center' },
        { text: 'Estado', value: 'condicion', sortable: true, width:'10%', align:'center' },
        { text: 'Acciones', value: 'action', sortable: false, width:'20%', align:'center' },
      ],
      loading: false,
      unidades: [],
      action: 0,
      errores: [],
      editedIndex: -1,
      editedItem: {
        codigo: '',
        nombre: '',
        abreviatura: '',
        numDimensiones: 1,
        idUnidadBase: -1,
      },
      defaultItem: {
        codigo: '',
        nombre: '',
        abreviatura: '',
        numDimensiones: 1,
        idUnidadBase: -1,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Unidad' : 'Editar Unidad'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        let me = this;
        me.setLoading(true);
        axios
        .get("/Unidades?incluirInactivos=true")
        .then(response =>  {
          me.unidades = response.data;
          me.setLoading(false);
          me.$emit("count-changed", (me.unidades || []).length);
        })
        .catch(error => {
          me.setLoading(false);
          console.log(error);
        });
      },
      setLoading(value) {
        this.loading = value;
        this.$emit("loading-changed", value);
      },
      openCreateExternal() {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.errores = [];
        this.dialog = true;
      },

      editItem (item) {
        this.action = 1;
        this.editedIndex = this.unidades.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      toggleEstado(item){
        let me = this;
        const idUnidad = item && item.idUnidad;
        if (!idUnidad) return;

        const activar = item.condicion === false;

        if (!activar && item.variablesAsociadas > 0) {
          me.verAsociaciones(item);
          me.estadoNonce += 1;
          return;
        }

        me.togglingId = idUnidad;
        axios
          .put("/Unidades/" + (activar ? "Activar" : "Desactivar") + "/" + idUnidad)
          .then(response =>  {
            me.initialize();
          })
          .catch(error => {
            const status = error && error.response ? error.response.status : null;
            if (!activar && status === 409) {
              me.verAsociaciones(item);
            } else {
              console.log(error);
            }
            me.initialize();
          })
          .finally(() => {
            me.togglingId = null;
            me.estadoNonce += 1;
          });
      },
      verAsociaciones(item){
        this.dependItem = item;
        this.dialogDependencias = true;
      },
      close () {
        this.action = 0,
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      validate(){
        this.errores =  [];
        if (
          !this.editedItem.codigo ||
          this.editedItem.codigo.trim().length < 1
        )
        {
          this.errores.push(
            "El codigo es requerido."
          );
          return false;
        }
        if (
          this.editedItem.nombre.length < 5 ||
          this.editedItem.nombre.length > 50
        )
        {
          this.errores.push(
            "El nombre debe tener más de 4 caracteres y menos de 50."
          );
          return false;
        }
        if (
          this.editedItem.abreviatura.length < 1 ||
          this.editedItem.abreviatura.length > 6
        )
        {
          this.errores.push(
            "La abreviatura debe tener al menos 1 caracter y menos de 5."
          );
          return false;
        }
        if (
          this.editedItem.numDimensiones > 1 &&
          (!this.editedItem.idUnidadBase || this.editedItem.idUnidadBase <= 0)
        )
        {
          this.errores.push(
            "Debe seleccionar una unidad base."
          );
          return false;
        }
        return true;
      },
      unidadesBase(){
        return this.unidades.filter(function(element){
          return element.numDimensiones == 1;
        });
      },
      save () {
        this.action = 0;
        if(this.validate()){
          let me = this;
          me.saving = true;
          if (this.editedIndex > -1)
          {
            //Código para editar
            axios
              .put("/Unidades/Actualizar/"+me.unidades[me.editedIndex].idUnidad, {
                Codigo: me.editedItem.codigo,
                Nombre: me.editedItem.nombre,
                Abreviatura: me.editedItem.abreviatura,
                NumDimensiones: me.editedItem.numDimensiones,
                IdUnidadBase: (me.editedItem.numDimensiones > 1) ? me.editedItem.idUnidadBase : null, 
              })
              .then(response =>  {
                me.saving = false;
                me.close();
                me.initialize();
              })
              .catch(error => {
                me.saving = false;
                if (error.response) {
                  if(error.response.status == 409){
                    me.alerta = true;
                    me.errores.push("Existe una Unidad Activa con el Mismo Nombre");
                  }
                }
              });
          }
          else
          {
            axios
              .post("/Unidades/Crear", {
                Codigo: me.editedItem.codigo,
                Nombre: me.editedItem.nombre,
                Abreviatura: me.editedItem.abreviatura,
                NumDimensiones: me.editedItem.numDimensiones,
                IdUnidadBase: (me.editedItem.numDimensiones > 1) ? me.editedItem.idUnidadBase : null,
              })
              .then(response =>  {
                me.saving = false;
                me.close();
                me.initialize();
              })
              .catch(error => {
                me.saving = false;
                if (error.response) {
                  if(error.response.status == 409){
                    me.alerta = true;
                    me.errores.push("Existe una Unidad Activa con el Mismo Nombre");
                  }
                }
              });
          }
        }
      },
    },
  }
</script>

<style scoped>
.unidad-embedded-container {
  padding: 0;
  max-width: none;
}
.unidad-embedded-container >>> .v-data-table {
  background: transparent;
}
.unidad-embedded-toolbar {
  padding: 0 0 8px;
}
.unidad-embedded-toolbar >>> .v-toolbar__content {
  padding: 0;
}
.estado-switch {
  display: inline-flex;
  margin-top: 0;
  padding-top: 0;
}
.asoc-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.25;
}
.asoc-cell__count {
  font-weight: 600;
  color: #334e68;
}
.asoc-cell__link {
  font-size: 12px;
  color: #1976d2;
  cursor: pointer;
}
.asoc-cell__link:hover {
  text-decoration: underline;
}
.asoc-cell__empty {
  font-size: 12px;
  color: #94a3b8;
}
.depend-dialog__title {
  font-weight: 700;
  color: #b45309;
  word-break: normal;
}
.depend-dialog__list {
  margin: 0;
  padding-left: 18px;
}
.depend-dialog__list li {
  margin-bottom: 2px;
}
</style>
